import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  ThirdTitle,
} from "../ContentsStyles";

const CG_12 = () => {
  return (
    <>
      <Parah>
        A top priority for Talents Explore is the safety and security of our
        users, creators, business partners, vendors, and employee data,
        including their personal information, accounts, profiles, content, and
        other proprietary information, as well as our product and services. We
        do not allow access to the Talents Explore platform -- which includes
        our website, app, network, and associated infrastructure or networks --
        through unauthorized methods, or to obtain sensitive confidential
        commercial or personal information. Any attempt to undermine or abuse
        the security, integrity or reliability of our platform, products, or
        services is expressly prohibited.
      </Parah>
      <ThirdTitle>Don not:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Attempt to access the Talents Explore platform in an unauthorized
        manner, and do not create fake or misleading versions of the Talents
        Explore platform.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Create or distribute malicious files, content, or messages that contain
        viruses, Trojan horses, worms, logic bombs, or other materials that may
        be harmful to the community or platform.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Use automated scripts, web crawling, software, deceptive techniques, or
        any other way to attempt to obtain, acquire, or request login
        credentials or other sensitive information, including non-public data,
        from Talents Explore or its users.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Leverage Talents Explore accounts under false or fraudulent pretences to
        distribute spam, phishing, or smishing content in an attempt to
        perpetrate cybercrime or gain unauthorized access to others’ content,
        accounts, systems, or data.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Modify, adapt, translate, reverse engineer, disassemble, decompile, or
        create any derivative products based on Talents Explore, including any
        files, tables or documentation, or attempt to regenerate any source
        code, algorithms, methods, or techniques embodied in Talents Explore.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Provide access to your account credentials to others or enable others to
        conduct activities against our Community Guidelines.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Click on suspicious links or engage in requests for information about
        your Talents Explore account details, passwords, verification
        qualification, financial, or other personal information.
      </PointsWrapper>
    </>
  );
};

export default CG_12;
